<div class="wrapper display-flex align-items-center justify-content-space-between bg-jet">
  <a
    class="logo color-white display-flex align-items-center justify-content-center ph-4 pl-0@tablet pr-0@tablet flex-shrink-0"
    data-cy="siteLogo"
    [routerLink]="['/next/search']"
  >
    @if (('mobile' | breakpointBelow) && environment.HEADER_MOBILE_LOGO_TYPE === 'initials') {
      <img alt="icon" class="logo__image" [src]="'logo-initials-white.svg' | assetUrl" />
    } @else {
      <img alt="icon" class="logo__image" [src]="'logo-icon-white.svg' | assetUrl" />
    }
  </a>

  @if ('mobile' | breakpointBelow) {
    <button
      class="nav-button position-relative display-flex align-items-center justify-content-center ph-4"
      data-cy="mobileMenu"
      (click)="siteNavService.toggle()"
    >
      @if (matchesDot$ | async) {
        <i class="nc-icon nc-circle indicator"></i>
      }
      <i class="nc-icon nc-menu icon i-4"></i>
    </button>
  }

  @for (link of links; track link.name) {
    <a
      class="nav-button position-relative display-flex align-items-center justify-content-center"
      id="navigation{{ link.name }}"
      routerLinkActive="active"
      [class.nav-button--optional]="link.optional"
      [routerLink]="link.routerLink"
    >
      @if (link.showIndicator$ | async) {
        <i class="nc-icon nc-circle indicator"></i>
      }
      @if (('mobile' | breakpointBelow) && link.iconName) {
        <i class="nc-icon icon i-4" [ngClass]="link.iconName"></i>
      }
      @if ('tablet' | breakpointAbove) {
        <span>{{ link.name }}</span>
      }
    </a>
  }

  @if (memberService.account.impersonated) {
    <div
      class="impersonation-mode position-absolute top-0 bottom-0 right-0 ph-4 font-weight-700 color-white text-transform-uppercase pointer-events-none bg-red t-7@r display-flex align-items-center justify-content-center"
    >
      Impersonation mode
    </div>
  }

  @if ('tablet' | breakpointAbove) {
    <div class="ml-auto">
      <sb-member-header-account />
    </div>
  }
</div>
